
export default class SimulacaoServicosCalcStore {

    concatServicos = (servicos = [], adicional = []) => {
        const servicosConcatenados = servicos.concat(adicional);

        return servicosConcatenados;
    }

    agrupaServicos = (servicos = []) => {
        // Agrupa os serviços
        const servicosAgrupados = servicos.reduce((acc, obj, _, array) => {
            const newQtd = array.reduce((accSub, objSub) => (objSub['Codigo'] == obj['Codigo'] ?  accSub + objSub['Qtd'] : accSub),0);

            if(!acc.some(item => obj['Codigo'] == item['Codigo'])) acc.push({...obj, Qtd: newQtd});
            
            return acc;
        },[]);

        return this.ordenaServicos(servicosAgrupados);
    }

    ordenaServicos = (servicos = []) => {
        // Ordena Serviços
        const servicosOrdenados = servicos.sort((a, b) => {
            if (a.Basico > b.Basico) return -1;
            if (a.Basico < b.Basico) return 1;            
            if (a.Servico > b.Servico) return 1;
            if (a.Servico < b.Servico) return -1;
            return 0;
        });

        return servicosOrdenados;
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosCalcStore.js